import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-areas-de-atuacao',
  templateUrl: './areas-de-atuacao.component.html',
  styleUrls: ['./areas-de-atuacao.component.scss']
})
export class AreasDeAtuacaoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
